import React from "react";
import "./ContactFixedButton.css";

const ContactFixedButton = () => {
  return (
    <>
      <a href="/contactus">
        <div className="internship-bar">
          <div className="internship-text">Contact Us</div>
        </div>
      </a>
    </>
  );
};

export default ContactFixedButton;
